export const fileNameRegex = /filename[^;=\n]*=['"].*?(\2|[^;\n'"]*)/;

export const getFileName = (contentDisposition: string): string => {
    const filenameMatches = fileNameRegex.exec(contentDisposition);
    return filenameMatches ? filenameMatches[1] : '';
};
